var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24994 4.75C9.24994 3.23122 10.4812 2 11.9999 2C13.5187 2 14.7499 3.23122 14.7499 4.75V4.91565C17.1349 5.2059 19.363 5.86798 21.3285 6.8258C21.7008 7.00725 21.8556 7.4562 21.6741 7.82855C21.4927 8.20091 21.0437 8.35566 20.6714 8.1742C18.1797 6.95998 15.2042 6.25 11.9999 6.25C8.79567 6.25 5.82012 6.95998 3.32848 8.1742C2.95613 8.35566 2.50718 8.20091 2.32572 7.82855C2.14427 7.4562 2.29902 7.00725 2.67137 6.8258C4.63686 5.86797 6.86496 5.2059 9.24994 4.91565V4.75ZM18.2653 18.283C18.1158 20.3763 16.374 21.998 14.2755 21.998H9.72445C7.62589 21.998 5.88413 20.3763 5.73461 18.283L5.04639 8.6479C7.16371 7.90959 9.5187 7.49805 12 7.49805C14.4812 7.49805 16.8362 7.90959 18.9536 8.6479L18.2653 18.283ZM10.75 10.998C10.75 10.5838 10.4142 10.248 9.99997 10.248C9.58576 10.248 9.24997 10.5838 9.24997 10.998V16.998C9.24997 17.4123 9.58576 17.748 9.99997 17.748C10.4142 17.748 10.75 17.4123 10.75 16.998V10.998ZM14 10.248C14.4142 10.248 14.75 10.5838 14.75 10.998V16.998C14.75 17.4123 14.4142 17.748 14 17.748C13.5858 17.748 13.25 17.4123 13.25 16.998V10.998C13.25 10.5838 13.5858 10.248 14 10.248Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.36d9ad153f210ab90ca409c090b5531e.svg";
export { ForwardRef as ReactComponent };